import script from "./BotMenuApp.vue?vue&type=script&setup=true&lang=js"
export * from "./BotMenuApp.vue?vue&type=script&setup=true&lang=js"

import "./BotMenuApp.vue?vue&type=style&index=0&id=47dd0fd8&scoped=true&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47dd0fd8"],['__file',"BotMenuApp.vue"]])

export default __exports__